export const ASSET_PATHS = {
  personCheckIcon: 'assets/icons/person-check.svg',
};
